import React from 'react';
import moment from 'moment';
import { UncontrolledTooltip } from 'reactstrap'
import ContractHdEl from './ContractHdEl';
import { getAccessToken } from '../../../utils';
import { displayDateFormat } from '../../../constants';
import { avationPlcInstance, leshaBankInstance, mtInstance } from '../../../shared_elements/components';
const ContractLeaseInfo = (props) => {

  return (
    <ul className="list-inline generate-select-boxes flex-centered">
      {!props.leaseInfo.same_operator_lessee ?
        <ContractHdEl title="Operator">
          {props.leaseInfo.operator.logo ?
            <img style={{ height: '28px', maxWidth: '102px' }} src={props.leaseInfo.operator.logo} alt={props.leaseInfo.operator.name} />
            : props.leaseInfo.operator.name?.length >= 14 ?
            <span>
                <p id="operatorName">
                  {props.leaseInfo.operator.name.slice(0, 10)}...
                </p>
                <UncontrolledTooltip placement="top" target="operatorName" >
                  {props.leaseInfo.operator.name}
                </UncontrolledTooltip>
              </span> : props.leaseInfo.operator.name
          }
        </ContractHdEl> : null
      }
      <ContractHdEl title="Lessee">
        <span>
          {props.leaseInfo.lessee.logo ?
            <img style={{ height: '28px', maxWidth: '102px', fontSize: '12px' }} src={props.leaseInfo.lessee.logo} alt={props.leaseInfo.lessee.name} />
            : props.leaseInfo.lessee.name?.length >= 20 ?
              <span>
                <p id="lesseeName">
                  {props.leaseInfo.lessee.name.slice(0, 10)}...
                </p>
                <UncontrolledTooltip placement="top" target="lesseeName" >
                  {props.leaseInfo.lessee.name}
                </UncontrolledTooltip>

              </span> : props.leaseInfo.lessee.name
          }
        </span>
      </ContractHdEl>
      <ContractHdEl title="Lease Start Date">
        <span>
          { (avationPlcInstance||mtInstance||leshaBankInstance)? props.leaseInfo?.titan_extra_fields?.contractual_delivery_date?
          moment(props.leaseInfo.titan_extra_fields?.contractual_delivery_date).format(displayDateFormat):'--':
          props.leaseInfo.contractual_start_date ?
            moment(props.leaseInfo.contractual_start_date).format(displayDateFormat)
            : '--'
          }
        </span>
      </ContractHdEl>
      {
         props.leaseInfo.lease_duration_type?.value != 3 ?
         <ContractHdEl title="Lease End Date">
        <span>
          {props.leaseInfo.contractual_end_date ?
            moment(props.leaseInfo.contractual_end_date).format(displayDateFormat)
            : '--'
          }
        </span>
      </ContractHdEl>: null
         }
      {
        props.leaseInfo.lease_duration_type?.value == 3 ?
          <ContractHdEl title="Lease Hours">
            <span>
              {props.leaseInfo?.utilized_lease_hours ? parseFloat(props.leaseInfo.utilized_lease_hours).toFixed(2) : '--'}
            </span>
          </ContractHdEl>
          :
          null
      }
          {
         props.leaseInfo.lease_duration_type?.value != 3 ?
      <ContractHdEl title="Lease Term">
        <span>{props.leaseInfo.lease_term ? props.leaseInfo.lease_term + props?.leaseInfo?.lease_term_unit ||'Months'  : '--'}</span>
      </ContractHdEl>
      :null}
      <ContractHdEl title="Remaining Lease Term">
        <span>{props.leaseInfo.remaining_lease_term ? props.leaseInfo.remaining_lease_term + props?.leaseInfo?.remaining_lease_term_unit ||'Months'  : '--'}</span>
      </ContractHdEl>
    </ul>
  )
}
export default ContractLeaseInfo
